import { SignalMap } from '../signal-map/signal-map';

// A unique symbol to use as the map value (since Sets only care about keys)
const PRESENT = Symbol('PRESENT');

/**
 * Class that provides a similar interface to the native Set but provides reactivity via signals
 * Prior art: https://github.com/ngxtension/ngxtension-platform/blob/main/libs/ngxtension/collections/src/signal-set.ts
 */
export class SignalSet<T> {
	private readonly storage = new SignalMap<T, typeof PRESENT>();

	constructor(values?: readonly T[] | null) {
		if (values) {
			for (const value of values) {
				this.storage.set(value, PRESENT);
			}
		}
	}

	public get size(): number {
		return this.storage.size;
	}

	public has(value: T): boolean {
		return this.storage.has(value);
	}

	public add(value: T): this {
		this.storage.set(value, PRESENT);
		return this;
	}

	public delete(value: T): boolean {
		return this.storage.delete(value);
	}

	public clear(): void {
		this.storage.clear();
	}

	public values(): T[] {
		return this.storage.keys();
	}

	public [Symbol.iterator](): IterableIterator<T> {
		return this.values()[Symbol.iterator]();
	}
}
